export default __webpack_public_path__ + "static/media/QF.60b2b8d4.png";